// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rfp-search {
  width: 100%;
  padding: 25px 0 22px 0;
}
.seller-rfp-main-div {
  height: 90vh;
}
.seller-rfp-heading-div {
  color: var(--Colors-Text-500, #0a0f0d);
  font-size: var(--Font-Font-Size-h5, 1.4375rem);
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #d2d2d2;
  padding-inline: 4rem;
}
.rfp-bread-crumb {
  padding-left: 4.326rem;
  padding-top: 1rem;
}
.seller-rfp-list-div {
  width: 100%;
  border-radius: 0.625rem;
  background: #fff;
  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);
  cursor: pointer;
}

.seller-rfp-headers {
  font-family: Roboto;
  color: var(--Colors-Text-300, #5b5e5d);
  font-size: var(--Font-Font-Size-small, 13px);
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  align-self: stretch;
}

.seller-rfp-text {
  font-family: Roboto;
  color: var(--Colors-Text-500, #0a0f0d);
  font-size: var(--Font-Font-Size-p, 14px);
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  align-self: stretch;
}

.seller-rfp-col {
  padding: 1.5rem;
  flex-direction: column;
  display: flex;
  min-width: 0;
}

.seller-rfp-status {
  display: flex;
  height: 2.1875rem;
  padding: 0.5rem;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
  background: #ffc107;
  border-top-right-radius: 0.625rem;
}

.seller-rfp-empty-list-div {
  margin-top: 5rem;
  border-radius: 0.625rem;
  background: #fff;
  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3rem;
  width: 30%;
}
.seller-rfp-list-main-div::-webkit-scrollbar {
  display: flex;
  width: 7px !important;
}

.seller-rfp-list-main-div::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.seller-rfp-list-main-div::-webkit-scrollbar-thumb {
  min-height: 18rem;
  background: var(--Colors-Text-200, #8e9190) !important;
  border-radius: 5px;
}

.seller-rfp-list-main-div::-webkit-scrollbar-thumb:hover {
  background: #5b5e5d;
}

.seller-rfp-list-main-div {
  margin-top: 1.88rem;
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  max-height: 80vh;
  overflow-y: scroll;
  overflow-x: hidden;
  padding-right: 1.7rem;
}

.seller-rfp-div {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.seller-rfp-list-child-div {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.seller-rfp-list-row {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.rfp-requests-row {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.rfp-name {
  max-width: 100%;
  display: inline-block;
}
@media (min-width: 0px) and (max-width: 320px) {
  .seller-rfp-heading-div {
    padding: 1.5rem 0.5rem 1rem 1.5rem;
    font-size: 1.3rem;
  }
}
@media (min-width: 321px) and (max-width: 375px) {
  .seller-rfp-heading-div {
    padding: 1.5rem 0.5rem 1rem 1.5rem;
    font-size: 1.3rem;
  }
  .rfp-bread-crumb {
    display: none;
  }
}

@media (min-width: 376px) and (max-width: 435px) {
  .seller-rfp-heading-div {
    padding: 1.5rem 0.5rem 1rem 1.5rem;
    font-size: 1.3rem;
  }
  .rfp-bread-crumb {
    display: none;
  }
}

@media (min-width: 436px) and (max-width: 570px) {
  .seller-rfp-heading-div {
    padding: 1.5rem 0.5rem 1rem 1.5rem;
    font-size: 1rem;
  }
  .rfp-bread-crumb {
    display: none;
  }
}

@media (min-width: 571px) and (max-width: 768px) {
  .seller-rfp-heading-div {
    padding: 1.5rem 0.5rem 1rem 1.5rem;
    font-size: 1.3rem;
  }
  .rfp-bread-crumb {
    display: none;
  }
}

@media (min-width: 769px) and (max-width: 785px) {
  .seller-rfp-heading-div {
    padding: 1.5rem 0.5rem 1rem 1.5rem;
    font-size: 1.3rem;
  }
}

@media (min-width: 786px) and (max-width: 816px) {
  .seller-rfp-heading-div {
    padding: 1.5rem 0.5rem 1rem 1.5rem;
    font-size: 1.3rem;
  }
}

@media (min-width: 817px) and (max-width: 1024px) {
  .seller-rfp-heading-div {
    padding: 1.5rem 0.5rem 1rem 1.5rem;
    font-size: 1.3rem;
  }
  .rfp-bread-crumb {
    padding-left: 2.326rem;
    padding-top: 1rem;
  }
}

@media (min-width: 1025px) and (max-width: 1440px) {
}

@media (min-width: 320px) and (max-width: 844px) {
  .seller-rfp-empty-list-div {
    margin-top: 2rem;
    width: 90%;
  }
  .seller-rfp-list-main-div {
    width: 92% !important;
    max-height: none;
    padding-right: 0%;
    overflow-y: hidden;
  }
  .seller-rfp-heading-div {
    border-bottom: none;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .seller-rfp-list-main-div {
    width: 95% !important;
  }
}
.email-wrap {
  word-break: break-word;
  white-space: normal;
}
`, "",{"version":3,"sources":["webpack://./src/features/SellerFlow/rfp-requests/RfpRequests.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,YAAY;AACd;AACA;EACE,sCAAsC;EACtC,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;EAChC,oBAAoB;AACtB;AACA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,kDAAkD;EAClD,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,kDAAkD;EAClD,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,UAAU;AACZ;AACA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,sDAAsD;EACtD,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;AACA;EACE;IACE,kCAAkC;IAClC,iBAAiB;EACnB;AACF;AACA;EACE;IACE,kCAAkC;IAClC,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,kCAAkC;IAClC,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,kCAAkC;IAClC,eAAe;EACjB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,kCAAkC;IAClC,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,kCAAkC;IAClC,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,kCAAkC;IAClC,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,kCAAkC;IAClC,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;AACF;;AAEA;AACA;;AAEA;EACE;IACE,gBAAgB;IAChB,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;AACA;EACE,sBAAsB;EACtB,mBAAmB;AACrB","sourcesContent":[".rfp-search {\n  width: 100%;\n  padding: 25px 0 22px 0;\n}\n.seller-rfp-main-div {\n  height: 90vh;\n}\n.seller-rfp-heading-div {\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-size: var(--Font-Font-Size-h5, 1.4375rem);\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid #d2d2d2;\n  padding-inline: 4rem;\n}\n.rfp-bread-crumb {\n  padding-left: 4.326rem;\n  padding-top: 1rem;\n}\n.seller-rfp-list-div {\n  width: 100%;\n  border-radius: 0.625rem;\n  background: #fff;\n  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);\n  cursor: pointer;\n}\n\n.seller-rfp-headers {\n  font-family: Roboto;\n  color: var(--Colors-Text-300, #5b5e5d);\n  font-size: var(--Font-Font-Size-small, 13px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  align-self: stretch;\n}\n\n.seller-rfp-text {\n  font-family: Roboto;\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-size: var(--Font-Font-Size-p, 14px);\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  align-self: stretch;\n}\n\n.seller-rfp-col {\n  padding: 1.5rem;\n  flex-direction: column;\n  display: flex;\n  min-width: 0;\n}\n\n.seller-rfp-status {\n  display: flex;\n  height: 2.1875rem;\n  padding: 0.5rem;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n  flex-shrink: 0;\n  background: #ffc107;\n  border-top-right-radius: 0.625rem;\n}\n\n.seller-rfp-empty-list-div {\n  margin-top: 5rem;\n  border-radius: 0.625rem;\n  background: #fff;\n  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 3rem;\n  width: 30%;\n}\n.seller-rfp-list-main-div::-webkit-scrollbar {\n  display: flex;\n  width: 7px !important;\n}\n\n.seller-rfp-list-main-div::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n.seller-rfp-list-main-div::-webkit-scrollbar-thumb {\n  min-height: 18rem;\n  background: var(--Colors-Text-200, #8e9190) !important;\n  border-radius: 5px;\n}\n\n.seller-rfp-list-main-div::-webkit-scrollbar-thumb:hover {\n  background: #5b5e5d;\n}\n\n.seller-rfp-list-main-div {\n  margin-top: 1.88rem;\n  width: 50%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1.5rem;\n  max-height: 80vh;\n  overflow-y: scroll;\n  overflow-x: hidden;\n  padding-right: 1.7rem;\n}\n\n.seller-rfp-div {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.seller-rfp-list-child-div {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n}\n\n.seller-rfp-list-row {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.rfp-requests-row {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.rfp-name {\n  max-width: 100%;\n  display: inline-block;\n}\n@media (min-width: 0px) and (max-width: 320px) {\n  .seller-rfp-heading-div {\n    padding: 1.5rem 0.5rem 1rem 1.5rem;\n    font-size: 1.3rem;\n  }\n}\n@media (min-width: 321px) and (max-width: 375px) {\n  .seller-rfp-heading-div {\n    padding: 1.5rem 0.5rem 1rem 1.5rem;\n    font-size: 1.3rem;\n  }\n  .rfp-bread-crumb {\n    display: none;\n  }\n}\n\n@media (min-width: 376px) and (max-width: 435px) {\n  .seller-rfp-heading-div {\n    padding: 1.5rem 0.5rem 1rem 1.5rem;\n    font-size: 1.3rem;\n  }\n  .rfp-bread-crumb {\n    display: none;\n  }\n}\n\n@media (min-width: 436px) and (max-width: 570px) {\n  .seller-rfp-heading-div {\n    padding: 1.5rem 0.5rem 1rem 1.5rem;\n    font-size: 1rem;\n  }\n  .rfp-bread-crumb {\n    display: none;\n  }\n}\n\n@media (min-width: 571px) and (max-width: 768px) {\n  .seller-rfp-heading-div {\n    padding: 1.5rem 0.5rem 1rem 1.5rem;\n    font-size: 1.3rem;\n  }\n  .rfp-bread-crumb {\n    display: none;\n  }\n}\n\n@media (min-width: 769px) and (max-width: 785px) {\n  .seller-rfp-heading-div {\n    padding: 1.5rem 0.5rem 1rem 1.5rem;\n    font-size: 1.3rem;\n  }\n}\n\n@media (min-width: 786px) and (max-width: 816px) {\n  .seller-rfp-heading-div {\n    padding: 1.5rem 0.5rem 1rem 1.5rem;\n    font-size: 1.3rem;\n  }\n}\n\n@media (min-width: 817px) and (max-width: 1024px) {\n  .seller-rfp-heading-div {\n    padding: 1.5rem 0.5rem 1rem 1.5rem;\n    font-size: 1.3rem;\n  }\n  .rfp-bread-crumb {\n    padding-left: 2.326rem;\n    padding-top: 1rem;\n  }\n}\n\n@media (min-width: 1025px) and (max-width: 1440px) {\n}\n\n@media (min-width: 320px) and (max-width: 844px) {\n  .seller-rfp-empty-list-div {\n    margin-top: 2rem;\n    width: 90%;\n  }\n  .seller-rfp-list-main-div {\n    width: 92% !important;\n    max-height: none;\n    padding-right: 0%;\n    overflow-y: hidden;\n  }\n  .seller-rfp-heading-div {\n    border-bottom: none;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 1024px) {\n  .seller-rfp-list-main-div {\n    width: 95% !important;\n  }\n}\n.email-wrap {\n  word-break: break-word;\n  white-space: normal;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
